const Divider = () => (
  <div className="h-px w-full border-b border-gray-200 border-dashed" />
);

export default Divider;
